module.exports = __webpack_public_path__ + "static/media/addHome.c9d39dff.png";